import type { CSSProperties } from "react";

import type { MapLayerMouseEvent } from "maplibre-gl";

import type { ExternalFeature, Trajectory } from "@/libs/models";
export interface SitumMapviewState {
  bearing: number;
  latitude: number;
  longitude: number;
  maxPitch: number;
  maxZoom: number;
  pitch: number;
  transitionDuration: number;
  transitionEasing: (t: number) => number;
  zoom: number;
}

export interface SliceProps {
  stylesheetId: string;
  selectedFeatures: string[];
  followUser: boolean;
  followUserLocked: boolean;
  controllerDisabled: boolean;
  mapViewState: SitumMapviewState;
  mapViewLimits: {
    minZoom: number;
    maxZoom: number;
    initialZoom: number;
    minPitch: number;
    maxPitch: number;
    initialPitch: number;
    initialLatitude: number | null;
    initialLongitude: number | null;
    minBearing: number;
    maxBearing: number;
    initialBearing: number;
    bboxPadding: number;
  };
  baseMapStyle: string;
  externalFeatures: ExternalFeature[];
  trajectory: Trajectory;
  fontSource: string;
  mapStyleLoaded: boolean;
  layerVisibility: LayerVisibility;
  cursor: CSSProperties["cursor"] | null;
  hasUserInteracted: boolean;
}

export type LayerVisibility = Record<LayerIndex, boolean>;

export type MapClickHandler = (e: MapLayerMouseEvent) => boolean | undefined;

export enum LayerIndex {
  FLOORPLAN = "maplibre-floorplan-layer",
  TILES = "maplibre-tiles-layer",
  IMDF = "maplibre-imdf-layer",
  CALIBRATION = "maplibre-calibration-layer",
  CALIBRATION_GTS = "maplibre-calibration-gts-layer",
  GEOFENCES = "maplibre-geofences-layer",
  ICONS_TEXT = "maplibre-cartography-iconstext-layer",
  MODELS = "maplibre-models-layer",
  PATHS = "maplibre-path-layer",
  DIRECTIONS = "maplibre-directions-layer",
  NAVIGATION = "maplibre-navigation-layer",
  POIS = "maplibre-poi-layer",
  FIND_MY_CAR = "maplibre-find-my-car-layer",
  ROUTE_LABELS = "maplibre-route-labels-layer",
  EXTERNAL_FEATURES = "maplibre-external-features-layer",
  TRAJECTORIES = "trajectories-layer",
  LOCATION = "maplibre-location-layer",
  EDITOR = "maplibre-editor-layer",
}
